import { Directive, HostListener, output } from '@angular/core';

@Directive({
  selector: '[panPasteFiles]',
  standalone: false,
})
export class PasteFilesDirective {
  readonly pasted = output<File[]>();

  @HostListener('paste', ['$event']) public onPaste(event: ClipboardEvent) {
    const items = event.clipboardData?.items;
    if (!items) return;

    const files: File[] = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.kind === 'file') {
        const file = item.getAsFile();
        if (file) files.push(file);
      }
    }

    if (files.length > 0) {
      event.preventDefault();
      this.pasted.emit(files);
    }
  }
}
